import styled from 'styled-components'
import { Dialog as DsDialog, getFontStyle } from '@diversioteam/diversio-ds'

import type { ITypeButtonProps, ICharacterHintProps } from './FeedbackModal.types'

export const Dialog = styled(DsDialog)`
    .MuiDialog-paper {
        max-width: 42rem;
        width: 100%;
        padding: 0;
        border-radius: 0.5rem;
        box-shadow:
            0 10px 15px -3px rgba(0, 0, 0, 0.1),
            0 4px 6px -2px rgba(0, 0, 0, 0.05);
        display: flex;
        flex-direction: column;
        max-height: 90vh;
    }

    .dds-dialog-title.MuiDialogTitle-root {
        ${getFontStyle('h3Semibold')}
        padding: calc(1.5rem + 8px) 1.5rem calc(0.5rem + 8px) 1.5rem;
        flex-shrink: 0;
    }

    .dds-dialog-content.MuiDialogContent-root {
        padding: 0 1.5rem 1.5rem 1.5rem;
        overflow-y: auto;
        overflow-x: visible;
        flex: 1;
        position: relative;
    }

    .dds-dialog-actions.MuiDialogActions-root {
        padding: 8px 1.5rem 1.5rem 1.5rem;
        flex-shrink: 0;
        border-top: 1px solid #e5e7eb;
        background-color: #f9fafb;
    }

    .dds-single-select__popper {
        z-index: 1400 !important;
    }
`

export const Description = styled.p`
    ${getFontStyle('p02Regular')}
    color: #6b7280;
    margin-bottom: 1.5rem;
`

export const SuccessContainer = styled.div`
    text-align: center;
    padding-top: 2rem;
    padding-bottom: 2rem;
`

export const SuccessIcon = styled.div`
    height: 4rem;
    width: 4rem;
    color: #10b981;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1rem;
`

export const SuccessTitle = styled.h3`
    ${getFontStyle('cardHeaderBold')} /* 18px, 700 weight - closest match to 1.25rem/600 */
    margin-bottom: 0.5rem;
    color: #111827;
`

export const SuccessMessage = styled.p`
    color: #6b7280;
`

export const DialogTitleContent = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`

export const TitleIcon = styled.div`
    height: 1.25rem;
    width: 1.25rem;
    color: #5e4ae3;
`

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
`

export const LocationContainer = styled.div`
    background-color: #f3f4f6;
    padding: 0.75rem;
    border-radius: 0.5rem;
    border: 1px solid #e5e7eb;
`

export const LocationLabel = styled.div`
    ${getFontStyle('p02Medium')} /* 14px, 500 weight - matches 0.875rem/500 */
    margin-bottom: 0.25rem;
    color: #111827;
`

export const FieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`

export const FieldLabel = styled.label`
    ${getFontStyle('p02Medium')} /* 14px, 500 weight - matches 0.875rem/500 */
    color: #111827;
`

export const TypeGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
`

export const TypeButton = styled.button<ITypeButtonProps>`
    padding: 0.75rem;
    border-radius: 0.5rem;
    border: 1px solid;
    transition: all 0.2s;
    cursor: pointer;
    background: none;
    border-color: ${(props) => (props.$isSelected ? '#5e4ae3' : '#e5e7eb')};
    background-color: ${(props) => (props.$isSelected ? 'rgba(94, 74, 227, 0.05)' : 'transparent')};

    &:hover {
        border-color: ${(props) => (props.$isSelected ? '#5e4ae3' : 'rgba(94, 74, 227, 0.5)')};
    }
`

export const TypeButtonContent = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`

export const TypeIcon = styled.div`
    height: 1rem;
    width: 1rem;
    color: currentColor;
`

export const TypeLabel = styled.span`
    ${getFontStyle('p02Medium')} /* 14px, 500 weight - matches 0.875rem/500 */
    color: #111827;
`

export const EmailHelpText = styled.p`
    ${getFontStyle('p03Regular')} /* 12px, 400 weight - matches 0.75rem */
    color: #6b7280;
`

export const ButtonContainer = styled.div`
    display: flex;
    gap: 0.75rem;
    width: 100%;
`

// New styled components for updated modal
export const ErrorText = styled.span`
    ${getFontStyle('p03Regular')}
    color: #dc2626;
    margin-top: 0.25rem;
    display: block;
`

export const CharacterHint = styled.span<ICharacterHintProps>`
    ${getFontStyle('p03Regular')}
    color: ${(props) => (props.$isValid ? '#16a34a' : '#6b7280')};
    margin-top: 0.25rem;
    display: block;
    font-style: italic;
`

export const SwitchContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;
    padding: 1rem;
    background-color: #f9fafb;
    border-radius: 0.5rem;
    border: 1px solid #e5e7eb;
`

export const SwitchLabel = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`

export const SwitchSubtext = styled.span`
    ${getFontStyle('p03Regular')}
    color: #6b7280;
    margin-top: 0.25rem;
    line-height: 1.4;
`

export const LoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.7);
    z-index: 1500;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.5rem;
`

export const ErrorContainer = styled.div`
    margin-top: 18px;
    display: flex;
    align-items: center;
    gap: 0.5rem;
`

export const ErrorIcon = styled.div`
    height: 1rem;
    width: 1rem;
    color: #dc2626;
    flex-shrink: 0;
`

export const ErrorMessage = styled.p`
    ${getFontStyle('p02Semibold')}
    color: #dc2626;
    margin: 0;
`
